import { normalizeCompanySlug, isReservedPortalSegment } from './companyUtils';
import {
  checkPortalSlugAvailability,
  getStorefrontCompanyBySlug,
  searchStorefrontCompanies,
} from '../../api/storefront/storefront';

export { isReservedPortalSegment };

export const getCompanySlug = (companyData) => {
  const directSlug = companyData?.portalSettings?.customUrl || companyData?.landingPageSettings?.customUrl;
  if (directSlug) {
    return normalizeCompanySlug(directSlug);
  }

  return '';
};

export const hasConfiguredClientExperience = (companyData) => {
  if (!companyData) return false;

  if (companyData.portalSettings?.isEnabled === true) {
    return true;
  }

  return Boolean(
    companyData.portalSettings?.customUrl ||
    companyData.landingPageSettings?.customUrl
  );
};

export const buildSharedSlugUpdate = (companyData, slug) => {
  const normalizedSlug = normalizeCompanySlug(slug);

  return {
    portalSettings: {
      ...(companyData?.portalSettings || {}),
      customUrl: normalizedSlug
    },
    landingPageSettings: {
      ...(companyData?.landingPageSettings || {}),
      customUrl: normalizedSlug
    }
  };
};

export const buildClientExperienceLinks = (companyData, baseUrl = typeof window !== 'undefined' ? window.location.origin : '') => {
  const slug = getCompanySlug(companyData);
  const root = (baseUrl || '').replace(/\/$/, '');

  return {
    slug,
    websiteUrl: slug && root ? `${root}/book/${slug}` : '',
    portalUrl: slug && root ? `${root}/book/${slug}` : ''
  };
};

export const findCompanyBySlug = async (slug) => {
  const normalizedSlug = normalizeCompanySlug(slug);
  if (!normalizedSlug || isReservedPortalSegment(normalizedSlug)) {
    return null;
  }

  try {
    return await getStorefrontCompanyBySlug(normalizedSlug);
  } catch (error) {
    if (error.status === 404) return null;
    throw error;
  }
};

export const searchCompaniesForBookingPortal = async (rawTerm) => {
  const term = (rawTerm || '').trim();
  if (term.length < 2) return [];
  return searchStorefrontCompanies(term);
};

export const isPortalSlugAvailableOnServer = async (slug, excludeCompanyId) => {
  const result = await checkPortalSlugAvailability(slug, excludeCompanyId);
  return result;
};
